export const ELSS_Data = "ELSS_Data"
export const ELSS_Data_RESPONSE = 'ELSS_Data_RESPONSE'
export const ELSS_Data_RESPONSE_FAIL = 'ELSS_Data_RESPONSE_FAIL'

export const ELSS_PDFDOWNLOAD = "ELSS_PDFDOWNLOAD"
export const ELSS_PDFDOWNLOAD_RESPONSE = 'ELSS_PDFDOWNLOAD_RESPONSE'
export const ELSS_PDFDOWNLOAD_RESPONSE_FAIL = 'ELSS_PDFDOWNLOAD_RESPONSE_FAIL'